import { getWebApp, tgVersionAtLeast } from '../telegram.ts'

/** Поля, которые могут удерживать экранную клавиатуру, включая редактор Telegram. */
export function isKeyboardField(element: Element | null): element is HTMLElement {
  return element instanceof HTMLElement && (
    element.isContentEditable
    || element.matches('textarea, input:not([type="button"]):not([type="checkbox"]):not([type="color"]):not([type="file"]):not([type="hidden"]):not([type="image"]):not([type="radio"]):not([type="range"]):not([type="reset"]):not([type="submit"])')
  )
}

/** Снять фокус и закрыть клавиатуру, даже если WebView уже потерял удалённое поле. */
export function dismissKeyboard(): void {
  if (isKeyboardField(document.activeElement)) document.activeElement.blur()
  if (!tgVersionAtLeast('9.1')) return
  try {
    getWebApp()?.hideKeyboard?.()
  } catch {
    // Старый или неполный SDK: DOM blur остаётся запасным путём.
  }
}

interface KeyboardLocation { pathname: string; search?: string }

/** Query-экраны отличаются от фильтров: ввод поиска через replace не теряет фокус. */
export function keyboardViewChanged(previous: KeyboardLocation, next: KeyboardLocation): boolean {
  if (previous.pathname !== next.pathname) return true
  const before = new URLSearchParams(previous.search)
  const after = new URLSearchParams(next.search)
  const keys = next.pathname === '/plan' ? ['card']
    : next.pathname.startsWith('/favorites/') ? ['post']
      : next.pathname === '/analytics' ? ['collection', 'editor'] : []
  return keys.some((key) => before.get(key) !== after.get(key))
}

/** Новый экран мог сам сфокусировать своё поле: не отнимать этот намеренный фокус. */
export function dismissPreviousKeyboard(previousFocus: Element | null): void {
  const current = document.activeElement
  if (isKeyboardField(current) && current !== previousFocus) return
  dismissKeyboard()
}
